import { SellerOnboardingCheckListConfig } from '../../../models/ClientModels';

export const getDefaultCheckListConfig = ({
  isCreator,
  isPslPayEnforced,
  isPslPayEnabled,
  overriddenRequired,
}: {
  isCreator: boolean;
  isPslPayEnforced: boolean;
  isPslPayEnabled: boolean;
  overriddenRequired?: boolean;
}): SellerOnboardingCheckListConfig => ({
  psl_pay: {
    sort_order: 10,
    required:
      overriddenRequired ?? (!isCreator && isPslPayEnforced && isPslPayEnabled),
    title: 'Get Paid via Stripe',
    description:
      'Everything you need to accept payments and run your shop with Stripe. Just hook up your bank account to get started.',
  },
  store_info: {
    sort_order: 20,
    required: overriddenRequired ?? true,
    title: 'Store Info',
    description:
      'Upload profile picture, set the name, bio and categories for your store',
  },
  store_reel: {
    sort_order: 30,
    required: overriddenRequired ?? true,
    title: 'Store Reel',
    description:
      'Introduce your store with a quick video about who you are and what you sell. (This reel will play on a loop when you do not have scheduled or live shows).',
  },
  business_location: {
    sort_order: 40,
    required: overriddenRequired ?? !isCreator,
    title: 'Business Location',
    description: 'Your business location is required to start selling',
  },
  shipping_options: {
    sort_order: 50,
    required: overriddenRequired ?? !isCreator,
    title: 'Shipping Options',
    description: 'Select and configure your preferred shipping option',
  },
  inventory_listings: {
    sort_order: 60,
    required: overriddenRequired ?? isCreator,
    title: 'Inventory',
    description:
      'You have to add at least {limit} products to your inventory before start selling',
  },
  store_favorites: {
    sort_order: 70,
    required: overriddenRequired ?? isCreator,
    title: 'Storefront',
    description:
      'You have to include at least {limit} products to your storefront, which are available for customers to purchase 24/7 via your PSL storefront, Store Reel, upcoming show’s Preview Video or by sharing the product listing’s url.',
  },
  commentchat: {
    sort_order: 80,
    required: overriddenRequired ?? true,
    title: 'CommentChat',
    description:
      'CommentChat can automatically respond to comments and send personalized DMs on your social selling channels.',
  },
});
